import {Alert, Button, Card, Col, Divider, Form, Input, message, Modal, Row, Space, Spin, Typography} from "antd";
import customerChangeRequestService from "../../service/customerChangeRequestService";
import React, {useEffect, useRef, useState} from "react";
import {ContactDetailDto} from "../../dto/ContactDetailDto";
import ErrorHandler from "../../util/ErrorHandler";
import Validation from "../../util/Validation";
import {
    EMAIL_MAX_LENGTH,
    EMAIL_VALIDATION,
    MOBILE_NUMBER_MAX_LENGTH,
    MOBILE_NUMBER_MIN_LENGTH,
    ONLY_NUMERIC_VALIDATION,
    OTP_DESTINATION_TYPE
} from "../../util/Constants";
import {
    MSG_OTP_IS_INVALID,
    MSG_OTP_SEND_FAILURE_ERROR,
    MSG_OTP_VERIFICATION_FAILURE_ERROR,
    MSG_OTP_VERIFICATION_SUCCESS,
    MSG_PLEASE_ENTER_A_VALID_EMAIL,
    MSG_VERIFY_YOUR_EMAIL_WARN,
    MSG_VERIFY_YOUR_MOBILE_NUMBER_AND_EMAIL_WARN,
    MSG_VERIFY_YOUR_MOBILE_NUMBER_WARN
} from "../../util/Messages";
import modal from "antd/es/modal";
import {CheckCircleOutlined, ExclamationCircleOutlined} from "@ant-design/icons";
import PhoneInput, {CountryData} from "react-phone-input-2";
import './style.scss';
import {OtpRequestDto} from "../../dto/OtpRequestDto";
import signupService from "../../service/signupService";
import {OtpDataDto} from "../../dto/OtpDataDto";
import {clearTimeout, setTimeout} from "worker-timers";
import {load} from "worker-timers-broker";
import {InputOTP} from "antd-input-otp";
import {ValidateOtpDto} from "../../dto/ValidateOtpDto";
import { PhoneNumberUtil } from 'google-libphonenumber';

interface ContactCrProps {
    cin: string
}
const SRI_LANKA_COUNTRY_CODE = "94";

const ContactDetailsChangeRequestComp = (props: ContactCrProps) => {
    type otpInputType =
        "numeric"
        | "alphabet"
        | "symbol"
        | "alphabet-symbol"
        | "alphabet-numeric"
        | "numeric-symbol"
        | "all";
    const otpApplicationId: string | undefined = process.env.OTP_APPLICATION_ID ? process.env.OTP_APPLICATION_ID : "";
    const otpFormRef: React.RefObject<HTMLFormElement> = React.createRef();
    const [value, setValue] = useState([]);
    const [contactDetails, setContactDetails] = useState<ContactDetailDto>()
    const [isFormFieldDisabled, setFormFieldDisabled] = useState<boolean>(false)
    const [isEditDisabled, setEditDisabled] = useState<boolean>(true)
    const [isLoading, setLoading] = useState<boolean>(false)
    const [form] = Form.useForm();
    const [otpData, setOtpData] = useState<OtpDataDto>({
        message: "",
        otpRef: "",
        refId: "",
        retryCount: 0,
        tokenLength: 6,
        validityPeriod: 120,
        resendPeriod: 120,
        tokenType: "numeric",
    });
    const [emailAndMobileNo, setEmailAndMobileNo] = useState({email: "", mobileNumber: ""});
    const [modalTitle, setModalTitle] = useState("");
    const [otpDestination, setOtpDestination] = useState({type: "", destination: "", maskedDestination: ""});
    const [timer, setTimer] = useState("");
    const timeoutRef = useRef<load>();
    const [isResendDisable, setIsResendDisable] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dialCode, setDialCode] = useState<string | null>(null);
    const [countryCode, setCountryCode] = useState("lk");
    const [isMobileNoVerifyDisabled, setMobileNoVerifyDisabled] = useState(true);
    const [isOtpVerified, setIsOtpVerified] = useState(false);
    const [isEmailVerifyDisabled, setEmailVerifyDisabled] = useState(true);
    const [isMobileVerified, setMobileVerified] = useState(false);
    const [isEmailVerified, setEmailVerified] = useState(false);
    const [mobileNoVerifiedStatus, setMobileNoVerifiedStatus] = useState(false);
    const [mobileNumber, setMobileNumber] = useState<string>("");
    const [emailAddress, setEmailAddress] = useState<string>("");
    const [emailVerified, setIsEmailVerified] = useState(false);
    const [isEmailOtpVerified, setEmailOtpVerified] = useState(false);
    const [isForeignUser, setForeignUser] = useState<boolean>(false)
    const [maxLengthOfContactNumber, setMaxLengthOfContactNumber] = useState<number>(9)
    const [countryCodeLength, setCountryCodeLength] = useState<number>(2)
    const phoneInputRef = useRef(null);
    useEffect(() => {
        getCustomerContactDetails()
    }, [])
    const getCustomerContactDetails = () => {
        setLoading(true)
        customerChangeRequestService.getCustomerContactDetailsList(props.cin).then((res) => {
            let contactDto = res.data.results as ContactDetailDto;
            if (contactDto) {
                setFormFieldDisabled(!contactDto.editable)
                setContactDetails(contactDto)
                setFormValues(contactDto)
                setLoading(false)
            } else {
                message.error("Customer contact detail fetch failure")
                setLoading(false)
            }
        }).catch(reason => {
            ErrorHandler.handleError(reason)
            setLoading(false)
        })
    }

    const onClickEdit = () => {
        setEditDisabled(!isEditDisabled)
        setFormValues(contactDetails)
    }

    const setFormValues = (data: ContactDetailDto | undefined) => {
        if (undefined != data) {
            form.resetFields(['mobileNumber']);
            form.setFieldsValue({
                email: data.email,
                homePhoneNumber: data.homePhoneNumber,
                officePhoneNumber: data.officePhoneNumber,
                faxNumber: data.faxNumber,
                mobileNumber: data.mobileNumber,
            })
            setMobileNumber(data.mobileNumber)
            setEmailAddress(data.email)
            setMobileVerified(true)
            setEmailVerified(true);
            if (phoneInputRef.current) {
                const countryData = phoneInputRef.current?.getCountryData();
                setContactNoLengths(countryData.countryCode.toUpperCase())
            }
        }
    }
    const getCleanedPhoneNumber = (phoneNumber: string) => {
        let replacedNumber = phoneNumber.replace(/\D/g, '');
        const maxLength = countryCodeLength + maxLengthOfContactNumber;

        return replacedNumber.length > maxLength ? replacedNumber.slice(0, maxLength) : replacedNumber
    }

    const validateEmail = (_: any, value: any) => {
        if (!value || value.length > EMAIL_MAX_LENGTH) {
            setEmailVerifyDisabled(true)
            return Promise.reject();
        }
        if (!EMAIL_VALIDATION.test(value)) {
            setEmailVerifyDisabled(true)
            return Promise.reject(MSG_PLEASE_ENTER_A_VALID_EMAIL);
        } else {
            setEmailVerifyDisabled(false)
            return Promise.resolve();
        }

    };
    const onSubmit = () => {
        form.validateFields().then(() => {
            let values: ContactDetailDto = form.getFieldsValue()

            values = {...values, mobileNumber: getCleanedPhoneNumber(values.mobileNumber)}
            if (validateChanges(contactDetails, values)) {

                if ((!isForeignUser && !isMobileVerified && !isOtpVerified) && (!isEmailVerified && !isEmailOtpVerified)) {
                    message.warning(MSG_VERIFY_YOUR_MOBILE_NUMBER_AND_EMAIL_WARN)
                } else if (!isForeignUser && !isMobileVerified && !isOtpVerified) {
                    message.warning(MSG_VERIFY_YOUR_MOBILE_NUMBER_WARN)
                } else if (!isEmailVerified && !isEmailOtpVerified) {
                    message.warning(MSG_VERIFY_YOUR_EMAIL_WARN)
                } else {

                    setLoading(true)
                    modal.confirm({
                        title: 'Confirm',
                        icon: <ExclamationCircleOutlined/>,
                        content: `Are you sure?, Do you want to update the contact details?`,
                        okText: 'Yes',
                        cancelText: 'No',
                        className: 'confirm-dialog-box',
                        okButtonProps: {style: {background: '#FF7400'}},
                        onOk() {
                            customerChangeRequestService.submitCustomerContactDetailChangeRequest(values, props.cin).then((res) => {
                                if (res.data.results) {
                                    message.success("Successfully submitted to authorization")
                                    setLoading(false)
                                    form.resetFields()
                                    setFormValues(contactDetails)
                                    setContactDetails(res.data.results)
                                    setFormFieldDisabled(true)
                                } else {
                                    message.error("Failed to submit for authorization")
                                    setLoading(false)
                                }
                            }, (reason) => {
                                ErrorHandler.handleError(reason);
                                setLoading(false)

                            })
                        },
                        onCancel() {
                            setLoading(false)
                        }
                    });
                }
            } else {
                message.warning("No changes detected")
            }
        }).catch(() => {

        })

    }
    const validateChanges = (oldValues: ContactDetailDto, newValues: ContactDetailDto) => {
        oldValues.mobileNumber = oldValues.mobileNumber.replace(/\D/g, '')
        newValues.mobileNumber = newValues.mobileNumber.replace(/\D/g, '')
        if (oldValues.mobileNumber != newValues.mobileNumber) {
            return true;
        } else if (validateFieldValues(oldValues.faxNumber) != validateFieldValues(newValues.faxNumber)) {
            return true;
        } else if (validateFieldValues(oldValues.officePhoneNumber) != validateFieldValues(newValues.officePhoneNumber)) {
            return true;
        } else if (validateFieldValues(oldValues.homePhoneNumber) != validateFieldValues(newValues.homePhoneNumber)) {
            return true;
        } else if (validateFieldValues(oldValues.email) != validateFieldValues(newValues.email)) {
            return true;
        }
    }

    const setContactNoLengths = (countryCode: string) => {
        const phoneUtil = PhoneNumberUtil.getInstance();
        const numberProto = phoneUtil.getExampleNumberForType(countryCode, 1);
        setMaxLengthOfContactNumber(numberProto.getNationalNumber().toString().length)
        setCountryCodeLength(numberProto.getCountryCode().toString().length)
    }
    const validateFieldValues = (value: any) => {
        return value ?? ""
    }
    const handlePhoneChange = (value: string, country: CountryData) => {
        setContactNoLengths(country.countryCode.toUpperCase())
        if (SRI_LANKA_COUNTRY_CODE !== country.dialCode) {
            setForeignUser(true)
        } else {
            setForeignUser(false)
        }
        const changedMobileNo = mobileNumber.replace(/\D/g, '')
        if (changedMobileNo == value) {
            setMobileVerified(true)
        }
        if (dialCode != country.dialCode) {
            form.resetFields(['mobileNumber']);
            setDialCode(country.dialCode)
            setCountryCode(country.countryCode)
            setMobileNoVerifyDisabled(true)
            setMobileVerified(false)
            setMobileNumber('')
        }
    };

    const generateMobileOrEmail = (type: OTP_DESTINATION_TYPE | string) => {
        let destination = "";

        otpFormRef.current?.resetFields();
        setValue([])

        if (type == OTP_DESTINATION_TYPE.EMAIL) {
            destination = form.getFieldValue("email");
            setEmailAndMobileNo({email: destination, mobileNumber: ""})
            setModalTitle("EMAIL VERIFICATION")
        } else if (type == OTP_DESTINATION_TYPE.SMS) {
            destination = form.getFieldValue("mobileNumber").replace(/\D/g, '');
            setEmailAndMobileNo({email: "", mobileNumber: destination})
            setIsOtpVerified(false);
            setModalTitle("MOBILE NUMBER VERIFICATION")
        }

        let otpRequestDto: OtpRequestDto = {
            userName: "",
            destinations: [{
                type: type,
                destination: destination
            }]
        }

        signupService.contactDetailChangeRequest(otpRequestDto).then((res: any) => {
            if (res.data !== null) {
                let otpData: OtpDataDto = res.data.results;
                setOtpData(otpData)
                setOtpDestination({
                    type: type,
                    destination: destination,
                    maskedDestination: maskEmailAndMobileNumber(destination)
                })
                showModal();
                countdown(true)
            } else {
                message.error(MSG_OTP_SEND_FAILURE_ERROR).then();

            }
        }, (reason) => {
            ErrorHandler.handleError(reason);

        })
    }

    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        countdown(false)
    };

    const countdown = (enable: boolean) => {
        let seconds = otpData.resendPeriod;
        setTimer("0:00")

        function tick() {
            const minutesRemaining = Math.floor(seconds / 60);
            const secondsRemaining = seconds % 60;
            --seconds;
            setTimer(`${minutesRemaining.toString().padStart(2, '0')}:${secondsRemaining.toString().padStart(2, '0')}`);
            if (seconds >= 0) {
                timeoutRef.current = setTimeout(tick, 1000);
                setIsResendDisable(true);
            } else {
                setIsResendDisable(false);
            }
        }

        if (enable) {
            tick()
        } else {
            if (typeof timeoutRef.current === "number") {
                clearTimeout(timeoutRef.current);
            }
        }
    }

    const maskEmailAndMobileNumber = (value: string) => {
        let isEmail = value.includes("@");
        let valueArr: string[];
        valueArr = value.split('');
        let finalArr: string[] = [];
        let len = value.indexOf('@') > -1 ? value.indexOf('@') : value.length - 2;
        if (isEmail) {
            valueArr.forEach((item: any, pos: number) => {
                (pos >= 1 && pos <= len - 2) ? finalArr.push('*') : finalArr.push(valueArr[pos]);
            })
            return finalArr.join('');
        } else {
            valueArr.forEach((item: any, pos: number) => {
                (pos <= len - 2) ? finalArr.push('*') : finalArr.push(valueArr[pos]);
            })
            return finalArr.join('');

        }
    }
    const onChangeMobileNo = (event: Event) => {
        // const replacedVal = ((event.target as HTMLInputElement).value)
        //     .replaceAll(' ', '').replaceAll('+', "")
        // const replacedPhoneNumber = emailAndMobileNo.mobileNumber.replaceAll(' ', '').replaceAll('+', "")
        const input = (event.target as HTMLInputElement).value;
        const replacedVal = input.replace(/\D/g, '');
        const replacedPhoneNumber = emailAndMobileNo.mobileNumber.replace(/\D/g, '');
        if (replacedVal != replacedPhoneNumber) {
            setMobileVerified(false);
            setIsOtpVerified(false)
            setMobileNoVerifyDisabled(true)
        } else {
            if (replacedVal == "" && replacedPhoneNumber == "") {
                setMobileVerified(false);
                setIsOtpVerified(false)
            } else if (mobileNoVerifiedStatus) {

                setMobileVerified(true);
                setIsOtpVerified(true)
            }
        }


    }

    const validateOtp = () => {
        let userOtp = otpFormRef.current?.getFieldValue("userOtp");
        if (!userOtp || userOtp.includes(undefined) || userOtp.includes("") || userOtp.length != otpData.tokenLength) {
            return otpFormRef.current?.setFields([
                {
                    name: "userOtp",
                    errors: [MSG_OTP_IS_INVALID]
                }
            ]);

        } else {
            let validateOtpDto: ValidateOtpDto = {
                refId: otpData.refId,
                appId: otpApplicationId,
                otp: userOtp.join(''),
                otpRef: otpData.otpRef
            }
            signupService.validateOtp(validateOtpDto).then((res: any) => {
                if (res.data !== null && res.data.status == "SUCCESS") {
                    message.success(MSG_OTP_VERIFICATION_SUCCESS).then();
                    handleOk();
                    otpValidStatusCheck(true);
                    countdown(false)
                } else {
                    message.error(MSG_OTP_VERIFICATION_FAILURE_ERROR).then();
                    otpValidStatusCheck(false);
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
                otpValidStatusCheck(false);
            })
        }
    }

    const otpValidStatusCheck = (value: boolean) => {
        if (otpDestination.type == OTP_DESTINATION_TYPE.SMS) {
            setIsOtpVerified(value);
            setMobileVerified(value);
            setMobileNoVerifiedStatus(value);
        } else if (otpDestination.type == OTP_DESTINATION_TYPE.EMAIL) {
            setIsEmailVerified(value);
            setEmailVerified(value);
            setEmailOtpVerified(value)
        }
    }
    const validatePhoneNo = (_: any, valueTemp: any) => {
        const value = form.getFieldValue("mobileNumber")

        if (value) {
            const valueWithoutSpaces = value.replace(/\D/g, '')
            const phoneWithoutCountryCode = valueWithoutSpaces.replace(`${dialCode}`, '');
            if (phoneWithoutCountryCode.startsWith('0')) {
                setMobileNoVerifyDisabled(true)
                return Promise.reject("Mobile number cannot start with zero");
            } else if (valueWithoutSpaces.length < MOBILE_NUMBER_MIN_LENGTH) {
                setMobileNoVerifyDisabled(true)
                return Promise.reject("Minimum of 7 characters are required");
            } else if (valueWithoutSpaces.length > MOBILE_NUMBER_MAX_LENGTH) {
                setMobileNoVerifyDisabled(true)
                return Promise.reject("The maximum length is 15 numbers");
            } else {
                setMobileNoVerifyDisabled(false)
                return Promise.resolve();
            }
        } else {
            setMobileNoVerifyDisabled(true)
            return Promise.reject();
        }

    };

    const onChangeEmail = (event: Event) => {
        let value = (event.target as HTMLInputElement).value;
        if (value != emailAddress) {
            setEmailVerified(false);
            setEmailOtpVerified(false);
        } else {
            if (emailAddress == value) {
                setEmailVerified(true)
            }
            if (value == "" && emailAndMobileNo.email == "") {
                setEmailVerified(false);
                setEmailOtpVerified(false);
            } else if (emailVerified) {
                setEmailVerified(true);
                setEmailOtpVerified(true);
            }
        }
    }
    return (
        <>
            <Spin spinning={isLoading}>

                <Row gutter={[24, 12]}>
                    {
                        isFormFieldDisabled ?
                            <Col span={24} style={{marginBottom: 8}}>
                                <Alert
                                    message="A new request cannot be processed because a request has already been raised."
                                    type="warning" showIcon/>
                            </Col>
                            :
                            <Col span={24} className={'request-screen-edit-btn-position'}>
                                <Space style={{float: 'right'}}>
                                    <Button
                                        style={{
                                            width: 84,
                                        }}
                                        onClick={onClickEdit}
                                    >
                                        Edit
                                    </Button>
                                </Space>
                            </Col>
                    }

                    <Col span={24}>
                        <Card title="Contact Details" className={"change_request_form"}>
                            <Form
                                className='form-input'
                                layout={"vertical"}
                                form={form}
                                onFinish={onSubmit}
                            >
                                <Row gutter={[12, 0]}>

                                    <Col xl={12} lg={12} md={24} sm={24} xs={24} className={"ant-col-xxl-12"}>
                                        <Form.Item style={{marginBottom: 8}}>
                                            <Form.Item
                                                label={
                                                    <>
                                                        {
                                                            isMobileVerified ?
                                                                <>
                                                                    Mobile Number <span style={{
                                                                    color: 'green',
                                                                    fontSize: 12,
                                                                    paddingLeft: 8
                                                                }}>Verified </span> <CheckCircleOutlined
                                                                    style={{color: 'green', fontSize: 10, padding: 3}}/>
                                                                </> :
                                                                <>Mobile Number</>
                                                        }

                                                    </>
                                                }
                                                name={"mobileNumber"}
                                                onChange={onChangeMobileNo}
                                                rules={[{required: true, message: 'Please enter your mobile number'},
                                                    {validator: validatePhoneNo}]}>
                                                <div style={{display: "flex"}}>
                                                    <PhoneInput
                                                        ref={phoneInputRef}
                                                        inputClass={isFormFieldDisabled || isEditDisabled ? 'phone-input-disable' : ''}
                                                        onChange={handlePhoneChange}
                                                        enableSearch={true}
                                                        country={countryCode}
                                                        countryCodeEditable={false}
                                                        value={mobileNumber}
                                                        disabled={isFormFieldDisabled || isEditDisabled}
                                                    />
                                                    {!isMobileVerified && !isForeignUser ?
                                                        <Button style={{marginLeft: 10}}
                                                                className={"otp_button_verify"}
                                                                type="link"
                                                                disabled={isFormFieldDisabled || isMobileNoVerifyDisabled}
                                                                onClick={!isMobileNoVerifyDisabled ? () => generateMobileOrEmail(OTP_DESTINATION_TYPE.SMS) : undefined}>
                                                            Verify
                                                        </Button> : <></>}
                                                </div>
                                            </Form.Item>
                                        </Form.Item>
                                    </Col>


                                    <Col xl={12} lg={12} md={24} sm={24} xs={24} className={"ant-col-xxl-12"}>
                                        <div style={{
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                            alignItems: "end"
                                        }} className={'change-email-input'}>
                                            <Form.Item style={{marginBottom: 8, width: '100%'}}

                                                       label={
                                                           <>
                                                               {
                                                                   isEmailVerified ?
                                                                       <>
                                                                           Email <span style={{
                                                                           color: 'green',
                                                                           fontSize: 12,
                                                                           paddingLeft: 8
                                                                       }}>Verified </span> <CheckCircleOutlined
                                                                           style={{
                                                                               color: 'green',
                                                                               fontSize: 10,
                                                                               padding: 3
                                                                           }}/>
                                                                       </> :
                                                                       <>Email</>
                                                               }

                                                           </>
                                                       }
                                                       name={"email"}
                                                       onChange={onChangeEmail}
                                                       onKeyPress={Validation.emailFieldValidation}
                                                       rules={[
                                                           {required: true, message: 'Please enter your email'},
                                                           {
                                                               max: EMAIL_MAX_LENGTH,
                                                               message: 'The maximum length is 254 characters'
                                                           },
                                                           {
                                                               type: 'email',
                                                               validator: validateEmail
                                                           },

                                                       ]}>
                                                <Input className={"email_input_width"} placeholder="Enter email"
                                                       disabled={isFormFieldDisabled || isEditDisabled}/>
                                            </Form.Item>

                                            {!isEmailVerified ?
                                                <div className={'change-email-verify-btn'}>
                                                    <Button
                                                        type="link"
                                                        disabled={isEmailVerifyDisabled || isFormFieldDisabled}
                                                        onClick={!isEmailVerifyDisabled ? () => generateMobileOrEmail(OTP_DESTINATION_TYPE.EMAIL) : undefined}
                                                        className={"otp_button_verify "}>
                                                        Verify
                                                    </Button>
                                                </div> : <></>}

                                        </div>

                                    </Col>

                                    <Col xxl={6} xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <Form.Item
                                            label="Fax"
                                            name={"faxNumber"}
                                            onKeyPress={Validation.isNumberWithoutDot}
                                            rules={[
                                                {
                                                    max: MOBILE_NUMBER_MAX_LENGTH,
                                                    message: 'The maximum length is 15 numbers'
                                                },
                                                {
                                                    pattern: ONLY_NUMERIC_VALIDATION,
                                                    message: 'These special characters are not allowed'
                                                }
                                            ]}>
                                            <Input placeholder="Enter fax number" disabled={isFormFieldDisabled || isEditDisabled}/>
                                        </Form.Item>
                                    </Col>

                                    <Col xxl={6} xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <Form.Item
                                            label="Office Phone Number"
                                            name={"officePhoneNumber"}
                                            onKeyPress={Validation.isNumberWithoutDot}
                                            rules={[
                                                {
                                                    max: MOBILE_NUMBER_MAX_LENGTH,
                                                    message: 'The maximum length is 15 numbers'
                                                },
                                                {
                                                    pattern: ONLY_NUMERIC_VALIDATION,
                                                    message: 'These special characters are not allowed'
                                                }
                                            ]}>
                                            <Input placeholder="Enter office phone number"
                                                   disabled={isFormFieldDisabled || isEditDisabled}/>
                                        </Form.Item>
                                    </Col>

                                    <Col xxl={6} xl={12} lg={12} md={12} sm={24} xs={24}>
                                        <Form.Item
                                            label="Residential Phone Number"
                                            name={"homePhoneNumber"}
                                            onKeyPress={Validation.isNumberWithoutDot}
                                            rules={[
                                                {
                                                    max: MOBILE_NUMBER_MAX_LENGTH,
                                                    message: 'The maximum length is 15 numbers'
                                                },
                                                {
                                                    pattern: ONLY_NUMERIC_VALIDATION,
                                                    message: 'These special characters are not allowed'
                                                }
                                            ]}>
                                            <Input placeholder="Enter residential phone number"
                                                   disabled={isFormFieldDisabled || isEditDisabled}/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </Col>
                    <Col span={24}>
                        <Divider style={{marginBottom: 12}}></Divider>
                    </Col>
                    <Col span={24}>
                        <Space style={{float: 'right'}}>
                            {/*<Button size={'large'} onClick={onCancel}*/}
                            {/*        style={{*/}
                            {/*            width: 120,*/}
                            {/*            marginRight: 8*/}
                            {/*        }}>Cancel</Button>*/}
                            <Button onClick={onSubmit} size={'large'} disabled={isFormFieldDisabled || isEditDisabled}
                                    style={{
                                        width: 120,
                                        background: "#FF7400",
                                        color: "white",
                                    }}>Submit</Button>
                        </Space>
                    </Col>
                </Row>
                <Modal title={modalTitle}
                       open={isModalOpen}
                       destroyOnClose={true}
                       maskClosable={false}
                       closable={false}
                       className='otp-verification-modal'
                       footer={[
                           <Button
                               // disabled={isResendDisable}
                               onClick={handleCancel}
                               className='otp-close-btn'>Close</Button>,
                           <Button type="success" onClick={validateOtp} className='otp-verify-btn'>Verify</Button>,
                       ]}>
                    <p className='otp-sent-info'>Enter the OTP sent
                        to <b>{otpDestination.maskedDestination}</b></p>

                    <Form name="complex-form" ref={otpFormRef}>
                        <Form.Item>

                            <Form.Item
                                noStyle
                                name="userOtp"
                                rules={[{validator: async () => Promise.resolve()}]}
                            >
                                <InputOTP length={otpData.tokenLength}
                                          inputType={otpData.tokenType.toLowerCase() as otpInputType}
                                          onChange={() => setValue}
                                          value={value}/>
                            </Form.Item>

                            <Typography href="#API">
                                <p>Didn't you receive the OTP?
                                    <Button type="link" disabled={isResendDisable}
                                            onClick={() => generateMobileOrEmail(otpDestination.type)}>
                                        Resend
                                    </Button>
                                    <span style={{float: 'right', paddingTop: 4}}>{timer}</span>
                                </p>
                            </Typography>


                        </Form.Item>
                    </Form>

                </Modal>
            </Spin>
        </>
    )
}
export default ContactDetailsChangeRequestComp;